import React from "react";

const CtaOne = () => {
  return (
    <section className="cta-one pb-5">
      <div className="container pb-5">
        <div className="cta-one__inner">

          {/* Background image */}
          <div
            className="cta-one__inner__bg"
            style={{
              backgroundImage:
                "url(assets/images/backgrounds/book-bg-1-1.jpg)", // update if you have Lotus Cab specific bg
            }}
          ></div>

          <div className="row">
            <div className="col-lg-6">
              <div className="cta-one__content">
                <div className="sec-title">
                  <div className="sec-title__top">
                    <div className="sec-title__shape"></div>
                    <h6 className="sec-title__tagline">Book Cab With Lotus Cab!!</h6>  {/* Updated tagline */}
                  </div>

                  <h3 className="sec-title__title">
                    High Comfort For Your Family
                  </h3>
                </div>

                <div className="cta-one__content__btn">
                  <a
                    href="/booking"  // Example booking page link
                    className="cityride-btn cityride-btn--border cityride-btn--lotus"
                  >
                    <span className="cityride-btn__icon">
                      <i className="icon-front-car"></i>
                    </span>
                    <span>Book Now</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Car Image */}
          <div className="cta-one__inner__image">
            <img
              src="/images/2.png" // Update with Lotus Cab car image
              alt="Lotus Cab Car"
            />
          </div>

          {/* Decorative shapes */}
          <div className="cta-one__inner__box">
            <div
              className="cta-one__inner__box__bg"
              style={{
                backgroundImage:
                  "url(assets/images/shapes/lotus-shape-1.jpg)", // Update shape if you have Lotus Cab shapes
              }}
            ></div>
            <div className="cta-one__inner__box__one"></div>
            <div className="cta-one__inner__box__two"></div>
          </div>

          <div className="cta-one__inner__item-one"></div>
          <div className="cta-one__inner__item-two"></div>

        </div>
      </div>
    </section>
  );
};

export default CtaOne;
